import React from "react";
import "../../../style/main.scss";
import material from "../../../assets/images/blog/material.png";
import { useTranslation } from "react-i18next";
const Banner = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="partner-banner v-center h-center flex-column">
        <div className="freebotdm-title v-center h-center flex-column">
          <h2 className="one">{t("How_to_build_a_bot")} </h2>
          <p className="large text-black">{t("Learn_how_to_build")}</p>
          <img src={material} alt="partner-image" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};
export default Banner;














